import type { ReactNode } from 'react';

import MotionMain from '../components/motion/Main';

type LayoutProps = {
  children: ReactNode;
};

const variants = {
  hidden: { opacity: 0, x: 0, y: 0 },
  enter: { opacity: 1, x: 0, y: 0 },
  exit: { opacity: 0, x: 0, y: 0 },
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <MotionMain
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{
        delay: 0.3,
        opacity: { duration: 1 },
        default: { ease: 'linear' },
      }}
    >
      {children}
    </MotionMain>
  );
};

export default Layout;
